/**
 * SacFilterType
 * @author ftgibran
 */

export enum SacFilterType {
  NF = 1,
  CORREIO = 3,
  PEDIDO = 4,
  DOC = 5,
  DANFE = 6,
}
